/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfPageStore, newEqualCondition } from '@tw/tw-runtime';
import { ResAddressDTO, ResAddressRestApiService } from '@tw/clvip-api-gen';

import { SettingAddressChoiceStoreState } from './type';

export class SettingAddressChoiceStore extends BfPageStore<SettingAddressChoiceStoreState> {
  private addressService: ResAddressRestApiService;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'setting/addressChoice'
        }
      }
    });
    this.addressService = new ResAddressRestApiService(this.appContext.getApiService());
  }

  async onLoad(param?: any): Promise<void> {
    await this.fetchListData();
  }

  async fetchListData() {
    this.setLoading(true);
    const userInfo = this.appContext.getUserStore().getState().userInfo;
    console.log('userInfo: ', userInfo);
    const addresses = await this.addressService.query({
      noPaging: true,
      conditions: [newEqualCondition(ResAddressRestApiService.EMPLOYEE_ID, userInfo.employee.id)]
    });

    console.log('addresses: ', addresses);
    this.setState({
      data: addresses.rows
    });
    this.setLoading(false);
  }

  // 设置默认地址
  selectDefaultAddress(record: ResAddressDTO) {
    this.addressService.update({
      ...record,
      isDef: true
    });
  }
}
